import { useEffect } from "react";

/**
 * useRegisterServiceWorker — registers /service-worker.js at root scope on mount.
 * Idempotent.
 */
export function useRegisterServiceWorker() {
  useEffect(() => {
    if (typeof navigator === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch(() => { /* silent */ });
  }, []);
}
